import { Transaction, VersionedTransaction } from "@solana/web3.js";
export async function deserializeTransaction(tx) {
    const buf = Buffer.isBuffer(tx) ? tx : Buffer.from(tx, 'base64');
    if ((buf[0] & 0x80) !== 0) {
        return VersionedTransaction.deserialize(buf);
    }
    else {
        return Transaction.from(buf);
    }
}
